import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const Fieldset = ui.S9Fieldset.default;
const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const CountryTemplateForm = ({ schema }: Props) => {
  const fields = [
    {
      field: 'country',
      colSize: 8,
      isReadOnly: true,
    },
    {
      field: 'last_published_dt',
      colSize: 8,
      isReadOnly: true,
    },
    {
      field: 'last_published_by_id',
      colSize: 8,
      isReadOnly: true,
    },
    {
      field: 'printable_requirements',
      colSize: 12,
    },
  ];

  return (
    <S9PageSection title="" size="sm">
      {schema && (
        <Fieldset
          context={{ id: undefined }}
          schema={schema}
          formFields={fields}
        />
      )}
    </S9PageSection>
  );
};

export default CountryTemplateForm;
